import { ConfirmDialog } from '@/components/organisms/ConfirmDialog';
import { truncateDescription } from './truncateDescription';

/**
 * **FI-46bis** — Dialog di conferma "tronca livelli successivi" per
 * l'edit retroattivo di un livello passato del PG. SSOT shared usato da:
 *  - **FI-46 PR-B** (edit level-up L2+): `LevelUpFlowPage` → all'apply
 *    se ci sono livelli L{editLevel+1}..L{current} da troncare.
 *  - **FI-46bis** (edit builder L1): `BuilderPage` edit-mode → all'apply
 *    se il PG era L>1.
 *
 * Molecule sottile sopra `ConfirmDialog` organism: incapsula la copy
 * `title` + `description` con plurale/singolare data-driven sui
 * `truncatedLevels`. Il consumer passa `editLevel` e `truncatedLevels`.
 *
 * **Non renderizza** se `truncatedLevels === 0` (caso edge: il livello
 * editato è già il corrente — nessun truncate necessario, la UI dovrebbe
 * applicare direttamente senza dialog).
 */
export interface TruncateLevelsDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  /** Livello che si sta editando (oggetto della modifica). */
  editLevel: number;
  /** Numero di livelli L{editLevel+1}..L{current} che verranno cancellati. ≥ 1 per renderizzare. */
  truncatedLevels: number;
}

export function TruncateLevelsDialog({
  open,
  onOpenChange,
  onConfirm,
  editLevel,
  truncatedLevels,
}: TruncateLevelsDialogProps) {
  if (truncatedLevels <= 0) return null;
  return (
    <ConfirmDialog
      open={open}
      onOpenChange={onOpenChange}
      variant="destructive"
      title={`Modificare L${editLevel} cancellerà i livelli successivi`}
      description={truncateDescription(editLevel, truncatedLevels)}
      confirmLabel={`Sì, modifica L${editLevel}`}
      cancelLabel="Annulla"
      onConfirm={onConfirm}
    />
  );
}
